<template>
  <span>
    <header-login v-if="$route.params.redirect===undefined"></header-login>
    <body-login v-if="$route.params.redirect===undefined"></body-login>
    <div v-else>Loading...</div>
    <!--<footer-login></footer-login>-->
  </span>
</template>
<script>
import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbvue/build/css/mdb.css';
import HeaderLogin from '@/components/ThemeMDB/pages/loginPage/Header';
import BodyLogin from '@/components/ThemeMDB/pages/loginPage/Body';
//import FooterLogin from '@/components/ThemeMDB/pages/loginPage/Footer';
export default {
    name: 'Login',
    components:{
        HeaderLogin,
        BodyLogin
       // FooterLogin      
    } 
};
</script>
